
export enum PayformPaidTypeCd {
	PAID = 'Paid',
	SPECIAL = 'Special',
	UNPAID = 'Unpaid'}

